<script setup lang="ts">
import { Button, Search } from 'vant';
import { $t } from '@repo/locales';

import { useFavoriteFabric } from './use-favorite-fabric.ts';

const { searchTerms, loadData } = useFavoriteFabric();

const onSearch = async () => {
  await loadData();
};
</script>

<template>
  <Search
    v-model="searchTerms"
    show-action
  >
    <template #action>
      <Button @click="onSearch" size="small">{{ $t('common.search') }}</Button>
    </template>
  </Search>
</template>

<style scoped>

</style>
